// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:14
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class ComputeStateArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.ComputeStateArgs';
  $t: string = 'SagaBase.Defines.ComputeStateArgs';

  public static GetMembers(): string[] {
    return ['StateUID', 'Method', 'MethodArgs', 'ArgValues', 'ReturnValue'];
  }

  public GetMembers(): string[] {
    return ComputeStateArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public StateUID: Guid = GuidTools.Empty;
  public Method: string;
  public MethodArgs: any[];
  public ArgValues: any[];
  public ReturnValue: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
